/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable guard-for-in */
/* eslint-disable camelcase */
import { Loader } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import {
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import { Link } from '@jutro/router';
import styles from './UsersList.module.scss'
import messages from './UsersList.messages';
import metadata from './UsersList.metadata.json5';
import AddUser from "../AddUser/AddUser"
import DeactivateAgency from "../DeactivateAgency/DeactivateAgency"
import DeactivateUser from "../DeactivateUser/DeactivateUser"
import EditUser from "../EditUser/EditUser"


function UsersList(props) {
    const { authHeader } = useAuthentication();
    const [showUserInfo, setShowUserInfo] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [agencyList, setAgencyList] = useState([]);
    const [showEdit, setShowEdit] = useState(false);
    const [userVM, setUserVM] = useState();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const [showAddUser, setShowAddUser] = useState(false)
    const [showDeactivateAgency, setDeactivateAgency] = useState(false)
    const [showActivateUser, setShowActivateUser] = useState(false);
    const [showDeactivateUser, setShowDeactivateUser] = useState(false);
    const [showUsersList, setShowUsersList] = useState(true);
    const [tableData, setTableData] = useState([])
    const [initialUserVM, setInitialUserVM] = useState({});
    const {
        usersData, groupPublicID, group, userVM: currentUserVM, associationName_TWIA
    } = props;
    // DE15327 agency with orgAdmin role
    const isAgencyOrgAdmin = group?.users?.value.some(obj => obj.isOrgAdmin);

    const isMasterGroup = _.get(group, 'isMasterGroup.value') // DE17917

    const getStatus = (item) => {
        if (item.status && item.status!=='Inactive') {
            return 'Active';
        }

        return item.isLocked_EXT && item.reason_EXT ? 'Suspended' : 'Inactive'; // DE17823 and DE15377 and DE15382
    };

    const resetUserData = useCallback(() => {
        const usersList = usersData.map(elt => ({
            firstName: elt.firstName,
            lastName: elt.lastName,
            userName_EXT: elt.userName_EXT,
            phoneNumber: elt.phoneNumber,
            email: elt.email,
            isEFTEnabled: elt.isEFTEnabled,
            status: getStatus(elt),
            publicID: elt.publicID,
            userRoles: elt?.userRoles
        }));

        setTableData(usersList);

        return usersList;
    }, [usersData]);

    useEffect(() => {
        const user = viewModelService?.create(
            selectedUser,
            'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.UserDTO'
        )

        setUserVM(user);
        resetUserData();

    }, [setUserVM, selectedUser, viewModelService, resetUserData]);




    const clickEdit = () => {
        setInitialUserVM(_.cloneDeep(userVM.value));
        setShowEdit(true);
    };

    // DE15289 setting visibility for EFT enabled column for TWIA
    const eftStatus = _.get(currentUserVM, 'associationName_TWIA.value.code')


    const getEftStatus = (item) => item.isEFTEnabled ? 'Yes' : 'No';

    const openUserInfo = (e, item) => {
        // e.preventDefault();
        const groupList = [];        
        // setIsLoadingData(true);

        if (associationName_TWIA === 'twia') {
            const userGroupPromise = AgencyAdminService.getUserGroupsList(item.publicID, authHeader).then((res) => {
                for (const key in res) {
                    const list = {};

                    list.agencyName = key;
                    list.isAdmin = res[key];
                    groupList.push(list);
                }

                setAgencyList(groupList);
            })

            Promise.all([userGroupPromise]).then(() => {
                setIsLoadingData(false);
            })
        } else {
            const userGroupPromise = AgencyAdminService.getUserGroupsLis_tfpa(item.publicID, authHeader).then((res) => {
                for (const key in res) {
                    const list = {};

                    list.agencyName = key;
                    list.isAdmin = res[key];
                    groupList.push(list);
                }

                setAgencyList(groupList);
            })

            Promise.all([userGroupPromise]).then(() => {
                setIsLoadingData(false);
            })
        }

        setSelectedUser(item);
        setShowUserInfo(true);
    };

    const getUsernameLink = (item) => (
        <Link onClick={e => openUserInfo(e, item)}>{item.userName_EXT}</Link>
    );

    const addNewUser = useCallback(() => {
        setShowAddUser(true);
        setShowUsersList(false);
    }, [])

    const deactivateAgency = useCallback(() => {
        setDeactivateAgency(true);
        setShowUsersList(false);
    }, [])


    const clickDeactivateUser = useCallback(() => {
        setShowDeactivateUser(true);
        setShowActivateUser(false);
        setShowUsersList(false);
    }, [])

    const clickActivateUser = useCallback(() => {
        setShowDeactivateUser(false);
        setShowActivateUser(true);
        setShowUsersList(false);
    }, [])

    const cancelDeactivateAgency = useCallback((value) => {
        if (value) {
            setDeactivateAgency(false);
            setShowUsersList(true);
        }
    }, [])

    if (isLoadingData) {
        return <Loader loaded={!isLoadingData} />;
    }

    const getUserTableVisible = () => {
        if(showAddUser) {
            return showUsersList
        }

        return !showUserInfo || showDeactivateAgency ? showUsersList : !showUserInfo
    }

    

    const searchTableFilter = filterValue => row => {
        const val = filterValue.toLowerCase();
        const eftValue = row.isEFTEnabled?"Yes":"No";
       

        return (
            row.firstName.toLowerCase().includes(val) ||
            row.lastName.toLowerCase().includes(val) ||
            row.status.toLowerCase().includes(val) ||
            row.phoneNumber.toLowerCase().includes(val) ||
            row.email.toLowerCase().includes(val) ||
            eftValue.toLowerCase().includes(val) ||
            row.userName_EXT.toLowerCase().includes(val)
        );
    };


    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        usersListTitle: { // DE15287
            content: group.isMasterGroup.value ? translator(messages.orgAdmin) : translator(messages.users)
        },
        usersInformation: {
            content: selectedUser.displayName
        },
        firstName: {
            readOnly: !showEdit,
        },
        lastName: {
            readOnly: !showEdit,
        },
        emailAddress: {
            readOnly: !showEdit,
        },
        phoneNumber: {
            readOnly: !showEdit,
        },
        buttonGroup: {
            visible: !showEdit,
        },
        userTable: {
          visible: getUserTableVisible()
        },
        status: {
            value: userVM?.status?.value // DE15377, DE15382, DE18917, DE18995
        },
        userInformation: {
            visible: showUserInfo
        },
        userListTable: {
            data: tableData,
            onFilter: searchTableFilter
        },
        userRolesTable: {
            data: selectedUser?.userRoles?.filter(role => role.isApplicable) // DE15372-To show only assigned roles in view mode
        },
        agencyListTable: {
            data: agencyList
        },
        agencyInformationTable: {
            visible: !showEdit
        },
        addUser: {
            groupPublicID,
            visible: showAddUser,
            usersData,
            isMasterGroup: group.isMasterGroup.value,// DE15326
            associationName_TWIA // Needed for add user
        },
        editUser: {
            visible: showEdit,
            agencyList,
            userListVM: userVM,
            onCancel: () => {
                setShowEdit(false)
                _.set(userVM, 'value', initialUserVM);
                setUserVM(userVM);
            },
            showEdit
        },
        activateUser: {
            visible: false
        },
        deactivateUserElement: {
            visible: showDeactivateUser || showActivateUser,
            userData: userVM,
            userActionFlag: showDeactivateUser === true ? 'deactivate' : 'activate'
        },
        deactivateAgencyButton: {
            visible: group.canDeactivate.value && isAgencyOrgAdmin && !isMasterGroup // DE17917
        },
        deactivateAgencyElement: {
            groupPublicID,
            visible: showDeactivateAgency,
            cancelDeactivateAgency
        },
        userInfoContainer: {
            visible: !showEdit
        },
        userRolesTableGridDiv: {
            visible: !showEdit
        },
        userRolesTableHeader: {
            visible: !showEdit
        },
        userRolesTableHeaderSpacing: {
            visible: !showEdit
        },
        eftEnableClumn: {
            visible: eftStatus === "twia"
        },
        userFullName: {
            content: !_.isUndefined(userVM) ? `${userVM.firstName.value}  ${userVM.lastName.value}` : ''
        },
        deactivateButton: {
            visible: !_.isUndefined(userVM) && !_.isUndefined(userVM.status) && userVM.status.value !=='Inactive'
        },
        activateButton: {
            visible: !(!_.isUndefined(userVM) && !_.isUndefined(userVM.status) && userVM.status.value === 'Inactive'
            && userVM.isLocked_EXT && !userVM.isLocked_EXT.value)
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            addUserComponent: AddUser,
            editUserComponent: EditUser,
            deactivateAgencyComponent: DeactivateAgency,
            deactivateUserComponent: DeactivateUser
        },
        resolveCallbackMap: {
            getUsernameLink,
            clickEdit,
            addNewUser,
            deactivateAgency,
            cancelDeactivateAgency,
            clickDeactivateUser,
            clickActivateUser,
            getStatus,
            getEftStatus

        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={userVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            isUsingNewValidation
        />
    );
}

UsersList.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};


UsersList.defaultProps = {

};

export default withAuthenticationContext(withRouter(UsersList));
